import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { Box } from '@mui/material';
// hooks
// import useResponsive from '../../hooks/useResponsive';
// components
// import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import ReportUserHeader from './header';
import ReportUserNavbar from './nav/ReportUserNavbar';
import { NAV } from '../../config-global';
// ----------------------------------------------------------------------

export default function ReportUserLayout() {
    //   const { themeLayout } = useSettingsContext();
    //   const isDesktop = useResponsive('up', 'lg');

    const IsFullScreen = useSelector(state => state.screen.fullScreenVale);
    const [open, setOpen] = useState(false);
    const [navWidth, setNavWidth] = useState(NAV.W_DASHBOARD);

    const handleOpen = () => {
        setOpen(true);
        setNavWidth(NAV.W_DASHBOARD);
    };

    const handleClose = () => {
        setOpen(false);
        setNavWidth(0);
    };

    //   const renderNavVertical = <JJMINavbar openNav={open} onCloseNav={handleClose} />;

    return (
        <>
            {!IsFullScreen && <ReportUserHeader openNav={open} onOpenNav={handleOpen} navWidth={navWidth} />}

            <Box
                sx={{
                    display: { lg: 'flex' },
                    minHeight: { lg: 1 },
                }}
            >
                <ReportUserNavbar openNav={open} onOpenNav={handleOpen} onCloseNav={handleClose} navWidth={navWidth} />

                <Main>
                    <Outlet />
                </Main>
            </Box>
        </>
    );
}
